import { CampaignFormData, CampaignTabs } from "@/components/screens/CampaignFormPage/types";
import { CampaignFormPageMessages } from "@/messages/campaigns/campaign-form-page.messages";
import { CampaignFormMessages } from "@/messages/campaigns/campaign-form.messages";
import { CampaignFormat, CampaignStatus, CampaignType } from "@/types/campaign.types";
import { SelectData, TabItem } from "@/types/form.types";
import { PlatformsName } from "@/types/platform.types";

export const TABS_ITEMS = (
  messages: CampaignFormPageMessages,
  campaignType?: CampaignType
): TabItem<CampaignTabs>[] => {
  const tabs = [
    { value: "campaignDataTab", label: messages.campaignDataSection },
    { value: "contactsDataTab", label: messages.contactsDataSection },
  ];

  if (campaignType !== CampaignType.SimpleMessage) {
    tabs.push({ value: "productsDataTab", label: messages.productsDataSection });
  } else {
    tabs.push({ value: "simpleMessageDataTab", label: messages.simpleMessageDataSection });
  }

  /*  if (isEditing) {
    tabs.push({ value: "exceptionLogsDataTab", label: exceptionLogsDataSection });
  } */

  return tabs as TabItem<CampaignTabs>[];
};

export const statusOptions = (messages: CampaignFormMessages, currentStatus: CampaignStatus) => {
  return Object.keys(CampaignStatus)
    .filter((key) => {
      const value = CampaignStatus[key as keyof typeof CampaignStatus];

      // Se o status atual for Hold ou Completed, apenas o próprio status deve ser exibido.
      if ([CampaignStatus.Hold, CampaignStatus.Completed].includes(currentStatus)) {
        return value === currentStatus;
      }

      // Se o status atual for Rejected, mostrar apenas o próprio status e opções de troca para Ativo, Inativo e Rascunho.
      if (currentStatus === CampaignStatus.Rejected) {
        return (
          value === CampaignStatus.Rejected ||
          value === CampaignStatus.Active ||
          value === CampaignStatus.Inactive ||
          value === CampaignStatus.Draft
        );
      }

      if (
        [CampaignStatus.Hold, CampaignStatus.Completed, CampaignStatus.Rejected].includes(value)
      ) {
        return false;
      }

      return true;
    })
    .map((key) => ({
      value: CampaignStatus[key as keyof typeof CampaignStatus],
      label: messages[`status${key}` as keyof CampaignFormMessages] || key,
    }));
};

export const typeOptions = (messages: CampaignFormMessages) => [
  {
    value: CampaignType.PromotionalPrice,
    label: messages.typePromotionalPrice,
  },
  {
    value: CampaignType.DiscountCoupon,
    label: messages.typeDiscountCoupon,
  },
  {
    value: CampaignType.SimpleMessage,
    label: messages.typeSimpleMessage,
  },
];

export const contactOriginOptions = (messages: CampaignFormMessages) =>
  Object.keys(PlatformsName).map((key) => ({
    value: PlatformsName[key as keyof typeof PlatformsName],
    label: messages[`type${key}` as keyof CampaignFormMessages],
  }));

export const isFieldDisabled = (values: CampaignFormData, field: string) => {
  if (values.isActiveStatus || values.isInactiveStatus) {
    // Lista explicitamente os campos que serão desabilitados quano o status for ativo ou inativo
    const disabledFields = [
      "code",
      "name",
      "type",
      "discountPercentage",
      "startDate",
      // Simple Message fields
      "simpleMessage",
      "hasButton",
      "buttonText",
      "buttonLink",
    ];
    if (field === "status" && values.isInactiveStatus) return false; // Permitir alteração de status apenas quando inativo
    return disabledFields.includes(field);
  }
  if (values.isHoldStatus || values.isConfirmedStatus) {
    return true; // Desabilitar tudo
  }
  if (values.isRejectedStatus || values.isDraftStatus) {
    return false; // Liberar tudo
  }
  return false; // Caso padrão, campos habilitados
};

export const FORMAT_OPTIONS = (
  messages: CampaignFormMessages
): SelectData<CampaignFormat | null>[] => {
  return [
    { value: CampaignFormat.Cart, label: messages.cartOption },
    { value: CampaignFormat.Catalog, label: messages.catalogOption },
  ];
};
